module.exports = __webpack_public_path__ + "img/crypto-seed-phrase-storage_B096J16JW2.d71398cd.jpg";